import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('libraryDependencyStore', Object.keys(state)),
	...mapGetters('libraryDependencyStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('libraryDependencyStore', Object.keys(actions)),
	...mapMutations('libraryDependencyStore', Object.keys(mutations))
};
